// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCc-rNLiIbucLTcAjbWDmI5ngr7rmhQpCY",
  authDomain: "atf-tattoo.firebaseapp.com",
  projectId: "atf-tattoo",
  storageBucket: "atf-tattoo.firebasestorage.app",
  messagingSenderId: "350745965616",
  appId: "1:350745965616:web:f8996c1459da324bd3a9f5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;